export const LOCAL_VIEW_ID_PREFIX = "localView";
export const DEFAULT_GRID_ID = 1;
export const MAIN_VIEW_ID = "main";



// WEBPACK FOOTER //
// ./src/consts/consts.js